import { render, staticRenderFns } from "./TicketTagControls.vue?vue&type=template&id=4eefb0a4&scoped=true&"
import script from "./TicketTagControls.vue?vue&type=script&lang=js&"
export * from "./TicketTagControls.vue?vue&type=script&lang=js&"
import style0 from "./TicketTagControls.vue?vue&type=style&index=0&id=4eefb0a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eefb0a4",
  null
  
)

export default component.exports